// /api/update-message-templates/{update_message_template_id}/
import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export const getUpdateTemplate = async (type: string) => {
  try {
    const response = await apiService.get(`/update-message-templates/${type}`);

    return response;
  } catch (error) {
    throw handleAxiosError(error);
  }
};
